(function () {
  'use strict';
  var POPUP_SELECTOR = '[data-search-popup]';
  var INPUT_SELECTOR = 'input[type="search"], input[name="q"]';
  var PLACEHOLDERS = ['Search sneakers, hoodies, caps…','Try "Air Force 1"…','Search by brand or style…','What are you looking for?'];
  var placeholderIdx = 0;

  function fixMobileLayout() {
    if (window.innerWidth >= 1024) return;

    // KEY FIX: theme positions result panel at left:235px on desktop layout - reset to 0 on mobile
    var resultPanel = document.querySelector('.m-search-popup__result');
    if (resultPanel) {
      resultPanel.style.setProperty('left', '0', 'important');
      resultPanel.style.setProperty('right', '0', 'important');
      resultPanel.style.setProperty('width', '100%', 'important');
      resultPanel.style.setProperty('max-width', '100%', 'important');
      resultPanel.style.setProperty('box-sizing', 'border-box', 'important');
    }

    var wrapper = document.querySelector('.m-search-result__group-wrapper');
    if (!wrapper) return;
    wrapper.style.cssText = 'display:block!important;width:100%!important;';

    wrapper.querySelectorAll('.m-search-result__group').forEach(function(g) {
      g.style.cssText = 'display:block!important;width:100%!important;flex:none!important;padding:0!important;border:none!important;max-width:100%!important;';
    });

    wrapper.querySelectorAll('.m-search-item--with-thumbnail').forEach(function(el) {
      el.style.cssText += 'width:100%!important;max-width:100%!important;box-sizing:border-box!important;';
    });

    wrapper.querySelectorAll('.m-search-item--title').forEach(function(el) {
      el.style.cssText += 'white-space:normal!important;overflow:visible!important;display:block!important;';
    });
  }

  function onDocClick(e) {
    var tag = e.target.closest('.m-search-popular--item');
    if (!tag) return;
    var popup = tag.closest(POPUP_SELECTOR);
    if (!popup) return;
    var input = popup.querySelector(INPUT_SELECTOR);
    if (!input) return;
    e.preventDefault();
    input.value = tag.textContent.trim();
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: ' ' }));
    input.focus();
  }

  function observeResults() {
    var mo = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.addedNodes.length) setTimeout(fixMobileLayout, 30);
      });
    });
    var popup = document.querySelector('.m-search-popup');
    if (popup) mo.observe(popup, { childList: true, subtree: true });
    mo.observe(document.body, { childList: true });
  }

  function startPlaceholderCycle() {
    setInterval(function() {
      placeholderIdx = (placeholderIdx + 1) % PLACEHOLDERS.length;
      document.querySelectorAll(POPUP_SELECTOR + ' ' + INPUT_SELECTOR).forEach(function(input) {
        if (document.activeElement !== input && !input.value) input.placeholder = PLACEHOLDERS[placeholderIdx];
      });
    }, 3200);
  }

  function init() {
    document.addEventListener('click', onDocClick);
    observeResults();
    startPlaceholderCycle();
    fixMobileLayout();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();